import React from 'react'
import cx from 'classnames'
import Image from 'components/Image'

import { CheckedIcon, ClockIcon, CloseIcon } from 'components/common'
import s from './BusinessListCard.module.css'
import { ServiceListBusiness } from 'components/common/types'
import { useRouter } from 'next/router'

interface Props {
  isInvoicesSelected:boolean
  data: ServiceListBusiness
  onSpecialClick: () => void
  onImageClick: () => void
  onClockIconClick: () => void
  onUploadClick: () => void
}

const BusinessListCard = ({
  isInvoicesSelected,
  data,
  onSpecialClick,
  onImageClick,
  onClockIconClick,
  onUploadClick
}: Props) => {
   const router = useRouter()
  const statusClass = cx(s.status, { [s['status--closed']]: !data.open })
  const link = `/biz/${data.slug}?invoices=true`

  const handlePayNowButtonClick = () => {
      router.push(link)
  }

  return (
    <div className={s.restaurantCard} key={data.id}>
      <div className={s.cardWrapper}>
        {!!data.special.length && (
          <span onClick={onSpecialClick} className={s.special}>
            Special
          </span>
        )}
        <div className={s.imgWrapper}>
          <Image
            key={data.id}
            alt={data.name}
            layout="fill"
            src={data.image ? data.image : '/food.jpg'}
            onClick={onImageClick}
          />
        </div>

        <div className={s.cardBody}>
          <div className={s.titleRow}>
            <h3 className={s.cardTitle}>{data.name}</h3>

            <div className={s.statusWrapper}>
              <span className={statusClass}>
                {data.open ? 'Open' : 'Closed'}
              </span>
            </div>
          </div>

          <div className={s.cardInfoRow}>
            <div className={s.packageInfoRow}>
              {data.show_delivery_methods && (
                <>
                  <div>
                    <span>Delivery</span>
                    {data.delivery ? (
                      <CheckedIcon fill="green" />
                    ) : (
                      <CloseIcon fill="red" />
                    )}
                  </div>
                  <div className={s.pickUpRow}>
                    <span> Pickup </span>
                    {data.pickup ? (
                      <CheckedIcon fill="green" />
                    ) : (
                      <CloseIcon fill="red" />
                    )}
                  </div>
                </>
              )}
            </div>

            <ClockIcon className={s.clockIcon} onClick={onClockIconClick} />
          </div>

          {data.distance_in_miles && (
            <div
              className="font-bold text-right mt-4"
              style={{ fontSize: '13.5px' }}
            >
              {data.distance_in_miles} Miles
            </div>
          )}
        </div>
        <div className={s.tagsRow}>
          {isInvoicesSelected ? (
            <p>{data.name} has sent you an invoice</p>
          ) : (
            !!data.keywords.length &&
            data.keywords.map((item, index) => (
              <span key={index} className={s.tag}>
                #{item}
              </span>
            ))
          )}
        </div>
        {data.custom_order_info?.AllowCustomOrderUpload && (
          <div className={s.tagsRow}>
            <button className={s.uploadShopingLstBtn} onClick={isInvoicesSelected ? handlePayNowButtonClick : onUploadClick}>
              {isInvoicesSelected ? "Pay Now" : data.custom_order_info?.LinkDisplayText}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default BusinessListCard
